window.jQuery = window.$ = require('jquery');
require("bootstrap/dist/js/bootstrap.bundle")
require("jquery-ui-slider/jquery-ui")
require("jquery-ui-slider/jquery-ui.css")
require('slick-carousel')
require('slick-carousel/slick/slick.css')
require('slick-carousel/slick/slick-theme.css')
require('svg-pan-zoom/dist/svg-pan-zoom.min')

jQuery(function ($) {
    let popovers = $('.ui-slider-popover div')

    $("#slider-range").slider({
        range: "min",
        min: 0,
        max: 100,
        value: 40,
        animate: "fast",
        slide: function (e, ui) {
            console.log(ui)
            popovers.each(function () {
                let elem = $(this)
                console.log(elem)
                if (elem.data('value') < ui.value) {
                    elem.addClass('active')
                } else {
                    elem.removeClass('active')
                }
            })
        },
        change: function (e, ui) {

        },
    })

    $('.slick').slick({
        mobileFirst: true,
        infinite: true,
        dots: false,
    })

    function LocationMap(container) {
        const locationMapBlock = container;
        const locationMapImageElement = locationMapBlock.querySelector(".js-location-map-image");
        const resetButton = locationMapBlock.querySelector(".js-location-map-reset-button");
        const zoomInButton = locationMapBlock.querySelector(".js-location-map-zoom-in-button");
        const zoomOutButton = locationMapBlock.querySelector(".js-location-map-zoom-out-button");
        const panZoomMapOptions = {
            mouseWheelZoomEnabled: false,
            preventMouseEventsDefault: false,
            minZoom: 0.6,
            maxZoom: 2.6,
            fit: false,
            contain: true,
            beforePan(oldPan, newPan) {
                const sizes = this.getSizes();
                const gutterWidth = sizes.width / 1.07;
                const gutterHeight = sizes.height / 1.07;
                const isWidthOversized = sizes.viewBox.width * sizes.realZoom > sizes.width;
                const isHeightOversized = sizes.viewBox.height * sizes.realZoom > sizes.height;
                const customPan = {};
                if (isWidthOversized) {
                    const leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth;
                    const rightLimit = sizes.width - gutterWidth - sizes.viewBox.x * sizes.realZoom;
                    customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
                } else {
                    customPan.x = (sizes.width - sizes.viewBox.width * sizes.realZoom) / 2;
                }
                if (isHeightOversized) {
                    const topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight;
                    const bottomLimit = sizes.height - gutterHeight - sizes.viewBox.y * sizes.realZoom;
                    customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y));
                } else {
                    customPan.y = (sizes.height - sizes.viewBox.height * sizes.realZoom) / 2;
                }
                return customPan;
            }
        };
        const panZoomMap = svgPanZoom(locationMapImageElement, panZoomMapOptions);
        panZoomMap.panBy({x: 0, y: 240});
        if (window.matchMedia("(min-width: 768px)").matches) {
            panZoomMap.zoom(0.6);
        }
        resetButton.addEventListener("click", () => {
            panZoomMap.reset();
        });
        zoomInButton.addEventListener("click", () => {
            panZoomMap.zoomIn();
        });
        zoomOutButton.addEventListener("click", () => {
            panZoomMap.zoomOut();
        });
    }

    const locationMapElement = document.querySelector(".js-location-map");
    if (locationMapElement) {
        new LocationMap(locationMapElement);
    }
})